module.exports = __webpack_public_path__ + "img/DE03734.2adf3887.png";